module.exports = __webpack_public_path__ + "img/9.79640389.png";